const standingsStyles = (theme) => ({
  container: {
    padding: theme.spacing(3),
  },
  header: {
    marginBottom: theme.spacing(3),
  },
  tableContainer: {
    marginTop: theme.spacing(2),
  },
  teamLogo: {
    width: 24,
    height: 24,
    marginRight: theme.spacing(1),
  },
  teamCell: {
    display: 'flex',
    alignItems: 'center',
  },
})

export default standingsStyles
